import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  min-height: 60vh;
  padding: 32px 16px;
  box-sizing: border-box;
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.secondary.orange50};
  color: ${({ theme }) => theme.palette.secondary.orange500};

  svg {
    width: 36px;
    height: 36px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: ${24 / 16}rem;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primary.blue900};
`;

export const Message = styled.p`
  margin: 0;
  max-width: 420px;
  font-size: ${15 / 16}rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.greyscale.grey600};
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 8px;
`;

export const PrimaryButton = styled.button`
  border: none;
  cursor: pointer;
  border-radius: 10px;
  padding: 12px 22px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: ${15 / 16}rem;
  font-weight: 600;
  color: #fff;
  background: ${({ theme }) => theme.palette.primary.blue500};
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.primary.blue600};
  }
`;

export const SecondaryButton = styled.button`
  cursor: pointer;
  border-radius: 10px;
  padding: 12px 22px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: ${15 / 16}rem;
  font-weight: 600;
  background: #fff;
  color: ${({ theme }) => theme.palette.greyscale.grey700};
  border: 1px solid ${({ theme }) => theme.palette.greyscale.grey200};
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.greyscale.grey50};
  }
`;
